import TelecallerLeadsApi from "../../services/api/TelecallerLeads";
import { getQueryParams } from "../../utils";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";

function handleError(err) {
  console.log("error in telecaller leads actions:", err);
}

export const setTelecallerLeads = (payload) => {
  return {
    type: ActionTypes.SET_TELECALLER_LEADS,
    payload,
  };
};

export const setReasons = (payload) => {
  return {
    type: ActionTypes.TELECALLER_LEADS_SET_REASONS,
    payload,
  };
};

export const setActiveLeadEngagement = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_LEAD_ENGAGEMENT,
    payload,
  };
};

export const setActiveFilterTelecallerLeads = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_FILTER_TELECALLER_LEADS,
    payload,
  };
};

export const setCurrentPageTelecallersLeads = (payload) => {
  return {
    type: ActionTypes.SET_CURRENT_PAGE_TELECALLERS_LEADS,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_TELECALLER_LEADS,
    payload,
  };
};

export const getReasons = () => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await TelecallerLeadsApi.getReasons();
    dispatch(setLoader(false));
    if (response) {
      dispatch(setReasons(response));
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getTelecallerLeads =
  (auth_id, pageRequest = {}) =>
  async (dispatch) => {
    try {
      const finalPayload = {
        ...pageRequest,
        telecaller_auth_id: auth_id,
      };
      const payload = getQueryParams(finalPayload);
      dispatch(setLoader(true));
      let response = await TelecallerLeadsApi.getTelecallerLeads(payload);
      dispatch(setLoader(false));
      if (response) {
        dispatch(setTelecallerLeads(response));
        if (Object.keys(pageRequest).length > 0) {
          dispatch(setCurrentPageTelecallersLeads(pageRequest.page_number));
        }
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const updateLeadEngagement = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await TelecallerLeadsApi.updateLeadEngagement(payload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(resetState({ state: "activeLeadEngagement" }));
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.UPDATION_SUCCESS,
        })
      );
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const filterLeadEngagement =
  (payload = {}, pageRequest = {}, auth_id) =>
  async (dispatch) => {
    try {
      const finalPayload = {
        ...payload,
        ...pageRequest,
        telecaller_auth_id: auth_id,
      };
      dispatch(setLoader(true));

      let response = await TelecallerLeadsApi.getFilterTelecallerLeads(
        finalPayload
      );
      dispatch(setLoader(false));
      if (response) {
        dispatch(setTelecallerLeads(response));
        if (Object.keys(pageRequest).length > 0) {
          dispatch(setCurrentPageTelecallersLeads(pageRequest.page_number));
        }
        if (Object.keys(payload).length > 0) {
          dispatch(setActiveFilterTelecallerLeads(payload));
        }
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };
